import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=5feba2e2&scoped=true&"
import script from "./TermsCondition.vue?vue&type=script&lang=js&"
export * from "./TermsCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermsCondition.vue?vue&type=style&index=0&id=5feba2e2&prod&lang=scss&"
import style1 from "./TermsCondition.vue?vue&type=style&index=1&id=5feba2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feba2e2",
  null
  
)

export default component.exports